// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"depression-test-phq-9_Wrapper___kt_K"};